import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { SelectInput } from '@hotelplan/components.common.select-input';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { useWishlistSelectedItemsContext } from 'fdr/components/candidate/fdr-wishlist/fdr-wishlist-selected-items-context';
import useWishlistCompareOptions from 'fdr/components/local/fdr-wishlist/fdr-use-wishlist-compare-options';
import {
  COMPARE_ITEMS_COUNT_DESKTOP,
  COMPARE_ITEMS_COUNT_MOBILE,
} from 'fdr/components/local/fdr-wishlist/fdr-wishlist.constants';
import {
  WishlistItemSelectSkeleton,
  WishlistItemsWrapper,
} from './WishlistItemSelect.skeleton';

const WishlistItemSelectWrapper = styled.div(({ theme: { space } }) => ({
  display: 'flex',
  marginBottom: space[3],
  flexWrap: 'wrap',
}));

const SelectInputWrapper = styled.div(
  sx2CssThemeFn({
    width: ['50%', `${100 / 3}%`],
    mx: [2, 3],
    overflow: 'hidden',
  })
);

export const WishlistItemSelect: React.FC = () => {
  const { mobile } = useDeviceType();
  const [t] = useTranslation('contact');

  const { items, itemsLoading, selectedItems, updateItem } =
    useWishlistSelectedItemsContext();

  const options = useWishlistCompareOptions(items, selectedItems);

  const onItemSelectChange = (value: string, index: number) => {
    const selectedWishlistItem = items?.find(wI => wI.product.id === value);

    updateItem(selectedWishlistItem ?? null, index);
  };

  if (itemsLoading) return <WishlistItemSelectSkeleton />;

  return (
    <WishlistItemSelectWrapper>
      <WishlistItemsWrapper>
        {Array.from({
          length: mobile
            ? COMPARE_ITEMS_COUNT_MOBILE
            : COMPARE_ITEMS_COUNT_DESKTOP,
        }).map((_, i) => {
          return (
            <SelectInputWrapper key={`select-${i}`}>
              <SelectInput
                hideLabel
                key={`select-${i}`}
                options={options[i]}
                value={selectedItems[i]?.product.id || ''}
                onChange={value => onItemSelectChange(value, i)}
                placeholder={t('contact:contactFormTypes.select.placeholder')}
              />
            </SelectInputWrapper>
          );
        })}
      </WishlistItemsWrapper>
    </WishlistItemSelectWrapper>
  );
};
